import React, {useEffect, useRef, useState} from "react";
import Slider from "react-slick";
import {sizes} from "../../../utils/styled/_variables.styled";
import targetView from "../../../utils/targetView";
import {RelatedContentOverlayCard} from "../Cards";
import {useIntersectionObserver, useUnsetGrid} from "../hooks";
import RelatedContentTitle from "../Title";
import RelatedSliderArrows from "./Arrows";
import RelatedSliderProgress from "./Progress";
import {RelatedSliderCard, RelatedSliderContainer} from "./style";

export const responsive = [{
	breakpoint: 1620,
	settings: {slidesToShow: 3.2, slidesToScroll: 3}
}, {
	breakpoint: sizes.tabletLarge - 1,
	settings: {slidesToShow: 2.2, slidesToScroll: 2}
}, {
	breakpoint: sizes.tabletSmall - 1,
	settings: {slidesToShow: 1.8, slidesToScroll: 1}
}, {
	breakpoint: sizes.mobile - 1,
	settings: {slidesToShow: 1.6, slidesToScroll: 1}
}, {
	breakpoint: sizes.mobile / 1.5,
	settings: {slidesToShow: 1.1, slidesToScroll: 1}
}]

const RelatedSlider = props => {
	const {
		title,
		titleUrl,
		titleUrlTarget,
		subtitle,
		showHighlightedDescription,
		linkText,
		componentType /* static or slider */,
		imageBackgroundColor,
		relatedContentSectionHtmlId /* div id */,
	} = props;

	const containerRef = useRef(null)
	const sliderRef = useRef(null)
	const [isFirstSlide, setIsFirstSlide] = useState(true)
	const [isLastSlide, setIsLastSlide] = useState(false)
	const [currentSlide, setCurrentSlide] = useState(0)
	const [totalScrolls, setTotalScrolls] = useState(0)
	const animate = useIntersectionObserver(containerRef)
	const contentList = (props.listFrom === 'auto') ? props.auto : props.manual
	const carouselSettings = {
		dots: true,
		arrows: false,
		swipeToSlide: false,
		infinite: false,
		slidesToShow: 3.25,
		slidesToScroll: 3,
		mobileFirst: true,
		initialSlide: 0,
		onReInit: () => {
			const currentBreakpoint = window.innerWidth;

			const breakpointSetting = [...responsive]
				.reverse()
				.find(item => currentBreakpoint <= item.breakpoint)?.settings;

			if (breakpointSetting) {
				const numberOfScrolls = Math.ceil((contentList?.length) / breakpointSetting.slidesToScroll);
				if (numberOfScrolls !== totalScrolls) {
					setTotalScrolls(numberOfScrolls);
					if(numberOfScrolls === 1) setIsLastSlide(true)
				}
			} else {
				console.error('No matching breakpoint found');
			}
		},
		beforeChange: (prevIndex, nextIndex) => {
			setIsLastSlide(!!(nextIndex % 1) || nextIndex === contentList?.length - 1)
			if (nextIndex !== prevIndex) {
				setCurrentSlide(Math.max(0, Math.min(totalScrolls, currentSlide + (nextIndex > prevIndex ? 1 : -1))));
			}
		},
		afterChange: (index) => {
			setIsFirstSlide(index === 0)
			setIsLastSlide(!!(index % 1) || index === contentList?.length - 1)
			targetView("slide-" + Math.ceil(index))
		},
		responsive
	}

	useUnsetGrid(containerRef)
	if (contentList?.length === 0) return <div style={{minHeight: '50px', display: 'flex', alignItems: 'center'}}><p>No
		content available, please check the authoring dialog.</p></div>;
	return <RelatedSliderContainer
		id={relatedContentSectionHtmlId}
		ref={containerRef}
		componentType={componentType}
		isLastSlide={isLastSlide}
		numberSlides={contentList?.length}
		currentSlide={currentSlide}
		totalScrolls={totalScrolls}
	>
		<div className="rel-content__section__header">
			<RelatedContentTitle title={title} titleUrl={titleUrl} titleUrlTarget={titleUrlTarget} subtitle={subtitle}/>
			<RelatedSliderArrows slider={sliderRef} isFirstSlide={isFirstSlide} isLastSlide={isLastSlide}/>
		</div>
		<RelatedSliderProgress/>
		<div className={`rel-content__section__items${animate ? ' animated' : ''}`}>
			<Slider ref={sliderRef} {...carouselSettings}>
				{contentList?.map((content, index) =>
					<RelatedSliderCard
						imageBackgroundColor={imageBackgroundColor || content?.searchResultItemDTO?.imageBackgroundColor}>
						<RelatedContentOverlayCard
							linkText={linkText} content={content} sliderVersion
							showHighlightedDescription={showHighlightedDescription}
							type="slider"
							key={`related-card-${index}`}
						/>
					</RelatedSliderCard>
				)}
			</Slider>
		</div>
	</RelatedSliderContainer>
}

export default RelatedSlider;
